import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import GatsbyImage from "gatsby-image"
import styled from "styled-components"

const logoQuery = graphql`
  query {
    file(relativePath: { eq: "contentful-logo-small.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`

const Logo = () => {
  const result = useStaticQuery(logoQuery)
  const image = result.file.childImageSharp.fluid
  const title = result.site.siteMetadata.title

  return (
    <Wrapper>
      <GatsbyImage fluid={image} alt={title} />
    </Wrapper>
  )
}

export default Logo

const Wrapper = styled.div``
